import Replacements from './Replacements';

export default Replacements;
